import { AbstractLayerState } from '../../../../../core/outputs/annotation/annotation-shared/state/layers/abstract-layer-state';
import { MeshLayerState } from '../../../../../core/outputs/annotation/annotation-shared/state/layers/mesh-layer-state';
import { ShapeLayerState } from '../../../../../core/outputs/annotation/annotation-shared/state/layers/shape-layer-state';
import { TransientLayerState } from '../../../../../core/outputs/annotation/annotation-shared/state/layers/transient-layer-state';
import { TransientShapeLayerState } from '../../../../../core/outputs/annotation/annotation-shared/state/layers/transient-shape-layer-state';
import { VectorLayerState } from '../../../../../core/outputs/annotation/annotation-shared/state/layers/vector-layer-state';

export function isVectorLayer(
  layer: AbstractLayerState,
): layer is VectorLayerState {
  return layer.type === 'vector_tagging';
}

export function isMeshLayer(
  layer: AbstractLayerState,
): layer is MeshLayerState {
  return layer.type === 'mesh';
}

export function isShapeLayer(
  layer: AbstractLayerState,
): layer is ShapeLayerState {
  return isTransientShapeLayerState(layer.transient);
}

export function isTransientShapeLayerState(
  transient: TransientLayerState,
): transient is TransientShapeLayerState {
  return 'tagEditorHidden' in transient;
}
